import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Loader, ViewContext } from "@/components/lib";
import Styles from "@/css/mainStyles";
import axios from "axios";

export default function ActivateModal({ id, setOpen }) {
  const viewContext = useContext<any>(ViewContext);
  const { handleSubmit } = useForm();

  const [loading, setLoading] = useState(false);

  const activateAccountSubmit = async () => {
    const url = `/api/player/${id}`;

    try {
      setLoading(true);
      await axios({
        method: "patch",
        url,
        data: { disabled: false }
      });
      viewContext.notification.show("Account activated", "success");
    } catch (error) {
      console.error(error);
      viewContext.notification.show(error.message, "error");
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(activateAccountSubmit)}>
      <h2 className="text-lg md:text-2xl font-bold mb-2">Reactivate Account</h2>
      <h3 className="text-sm md:text-2xl mb-4">
        Your account is currently deactivated. Would you like to reactivate your
        account to continue using the platform?
      </h3>
      <p className="text-sm md:text-lg text-gray-600 mb-4">
        Reactivating your account will restore your profile and data, making it
        visible to other users again.
      </p>

      <div className="flex justify-between mt-4 gap-4">
        <button onClick={() => setOpen(false)} className={Styles.cancelButton}>
          Cancel
        </button>
        <button className={Styles.blueButton}>
          Confirm {loading && <Loader />}
        </button>
      </div>
    </form>
  );
}
